import { gql } from "@apollo/client"

const DELETE_BOOKING_SLOT_MUTATION = gql`
  mutation deleteBookingSlot($input: DeleteBookingSlotInput!) {
    deleteBookingSlot(input: $input) {
      id
      bookingSlots {
        id
        slot_id
      }
    }
  }
`

export default DELETE_BOOKING_SLOT_MUTATION